module.exports = __webpack_public_path__ + "static/media/adam-compressed.f0f32fbf.png";